<template>
  <FITFormCard>
    <div slot="header">
      <p class="h5">List of Lead</p>
    </div>
    <div slot="formBody">
      <b-row class="justify-content-md-center">
        <b-col cols="2" v-for="key in filterKeys">
          <FITSelect v-if="filters[key].type === 'select'" v-model="filters[key].value" :label="filters[key].label" :options="filters[key].options"></FITSelect>
          <FITDatePicker v-if="filters[key].type === 'datetime'" v-model="filters[key].value" :label="filters[key].label">
          </FITDatePicker>
        </b-col>
        <b-col cols="1">
          <FITButton :text="$t('crm.lead.clear')" @click="clearFilter" size="md" faIcon="fa-times-circle" variant="danger">
          </FITButton>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <FITTextInput :label="keywords.label" :placeholder="keywords.label" v-model="keywords.value"></FITTextInput>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table class="pointer-cursor" outlined fixed hover responsive :items="data.list" :fields="fields" @row-clicked="onRowSelected">
            <slot name="columns"></slot>
            <!--
            <template slot="type" slot-scope="row">
              {{ getConvertedString('leadTypes', row.value) }}
            </template>
            <template slot="dateOfContact" slot-scope="row">
              {{ row.value | date }}
            </template>
            <template slot="name" slot-scope="row">
              {{ row.value }}
            </template>
            <template slot="status" slot-scope="row">
              {{ getConvertedString('leadStatus', row.value) }}
            </template>
            <template slot="createTime" slot-scope="row">
              {{ row.value }}
            </template>
            <template slot="updateTime" slot-scope="row">
              {{ row.value }}
            </template> 
       		-->
          </b-table>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col cols="10" class="text-left">
          <span class="text-secondary">{{ total }}</span>
        </b-col>
        <b-col cols="2" class="text-right">
          <FITPagination :disabled="busy" :totalRows="data.total" :perPage="pagination.perPage" size="md" @input="onPageChanged" v-model="pagination.currentPage"></FITPagination>
        </b-col>
      </b-row>
    </div>
  </FITFormCard>
</template>
<script type="text/javascript">
import {
  FITPagination,
  FITFormCard,
  FITSelect,
  FITButton,
  FITTextInput,
  FITDatePicker
} from '@/components';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'PolicyList',
  components: {
    FITPagination,
    FITFormCard,
    FITSelect,
    FITButton,
    FITTextInput,
    FITDatePicker
  },

  props: {
    searchAction: {
      type: String,
      required: true
    },
    filters: {
      type: Object,
      required: true
    },
    keywords: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      data: {
        total: 0,
        list: []
      },

      pagination: {
        currentPage: 1,
        perPage: 20
      },

      // fields: [
      //   { key: 'type', label: this.$t('crm.lead.create.type'), class: '' },
      //   { key: 'dateOfContact', label: this.$t('crm.lead.create.dateOfContact') },
      //   { key: 'name', label: this.$t('crm.lead.create.name') },
      //   { key: 'status', label: this.$t('crm.lead.create.status') },
      //   { key: 'createTime', label: this.$t('crm.lead.create.createTime') },
      //   { key: 'updateTime', label: this.$t('crm.lead.create.updateTime') }
      // ],

      busy: false,
      timeout: null
    }
  },

  computed: {
    ...mapGetters('Crm', [
      'getTranslated'
    ]),

    filterKeys() {
      return Object.keys(this.filters);
    },

    total() {
      return `${this.$t('crm.lead.page')} ${this.pagination.currentPage} / ${this.$t('crm.lead.total')} ${this.data.total} ${this.$t('crm.lead.items')}`;
    },

  },

  watch: {
    pagination: {
      deep: true,
      handler(val) {
        this.refreshPage();
      }
    },

    search: {
      handler(val) {
        if (this.busy) {
          return;
        }

        Vue.set(this, 'busy', true);
        if (timeout) {
          clearTimeout(this.timeout);
        }

        let timeout = setTimeout(() => {
          Vue.set(this, 'busy', false);
          Vue.set(this, 'timeout', null);
        }, 1500);

        var result = {};
        Object.keys(this.search).forEach((key) => {
          if (this.search[key] != null &&
            this.search[key].trim().length > 0) {
            result[key] = this.search[key];
          }
        });

        this.refreshPage(result);
      },
      deep: true // watch nested
    }
  },

  methods: {
    clearFilter() {
      Vue.set(this, 'busy', false);

      Vue.set(this, 'search', {
        search: null,
        type: null,
        status: null,
        leadLevel: null,
        dateFrom: null,
        dateTo: null,
      });
    },

    addGeneralAll(options) {
      options.unshift({
        value: null,
        text: this.$t('general.all')
      });
      return options;
    },

    onRowSelected(item, index, event) {


      this.$router.push({
        name: 'Create Lead',
        params: { ID: parseInt(item.ID) }
      });
    },

    getConvertedString(key, value) {
      let result = this[key].filter((item) => {
        return item.value === value;
      });

      if (result.length > 0) {
        return result[0].text;
      }

      return 'N/A';
    },

    onPageChanged(newPage) {
      Vue.set(this.pagination, 'currentPage', newPage);
    },

    refreshPage(param = {}) {
      this.$store.dispatch('Crm/getLeadList', {
        page: this.pagination.currentPage,
        count: this.pagination.perPage,
        ...param
      }).then((json) => {
        console.debug(json);
        Vue.set(this, 'data', json);
      }).catch((err) => {
        console.error(err);
      });
    }
  },

  created() {
    this.$store.dispatch('getAllSelections', 'lead')
      .then((json) => {
        this.$store.commit({ type: 'Crm/setSelections', selection: json.data });
      })
      .catch((err) => {
        console.error(err);
      });
    this.refreshPage();
  }
}

</script>
<style>
.pointer-cursor .table tbody tr,
.pointer-cursor .table tbody td {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/Crm/components/Policy/PolicyList.vue